import { render, staticRenderFns } from "./HomeRegistration.vue?vue&type=template&id=1fc76adc&"
import script from "./HomeRegistration.vue?vue&type=script&lang=js&"
export * from "./HomeRegistration.vue?vue&type=script&lang=js&"
import style0 from "./HomeRegistration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports